<template>
  <div class="home">
    <div class="header-banner">
      <!-- <BannerSlider /> -->
      <SearchbarContainer />

      <Carousel />

      <HomePageLists />

      <FooterBar />

      <PopupModal
        v-bind:popData="this.popupBanner"
        v-show="isModalVisible"
        @close="closeModal"
      />
      <!-- <Popup /> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from "vuex";
import { LocationId } from "../../services/storage.service";
import { GetBannerService } from "../../services/items.service";
// import BannerSlider from "./BannerSlider/BannerSlider.vue";
import Carousel from "./BannerSlider/Carousel.vue";
import { BannerCara } from "./data";
import router from "../../router";
import HomePageLists from "../List/HomePageLists";
import FooterBar from "../../components/FloatingFooter/FooterBar";
import PopupModal from "../../components/Popup/PopupModal.vue";
// import Popup from "../../components/Popup/Popup.vue";

import SearchbarContainer from "../../components/SearchbarContainer/SearchbarContainer.vue";
import QrcodeVue from "qrcode.vue";

export default {
  name: "home",
  components: {
    // BannerSlider,
    Carousel,
    HomePageLists,
    FooterBar,
    PopupModal,
    // Popup,
    SearchbarContainer,
    QrcodeVue,
  },
  data() {
    return {
      showPopup: true,
      sliderData: BannerCara,
      isModalVisible: false,
      popupBanner: [],
      loc_id: LocationId.getLocationId(),
      orderNumber: "000004",
      value:
        "00020101021226450011fonepay.com0716222212000048434909067654295204581253035245402145802NP5932KHAANPINFOODSANDTOURSPVTLTD6012KathmanduMP62430106765429050510003070548437081110003;test263040092",
      size: 300,
    };
  },
  computed: {
    ...mapGetters(["getIsRegistered", "currentLocation"]),
  },

  beforeCreate() {},

  created() {
    window.scrollTo(0, 0);

    this.updateStep(0);

    this.checkParams();

    let that = this;
    if (LocationId.getLocationId() === null) {
      this.$confirm({
        title: "Please choose your delivery location",
        okText: "Pokhara",
        okType: "primary",
        cancelText: "Kathmandu",
        onOk() {
          that.updateLocationId(2);
          router.push("/pkr");
          that.clearCart();
          that.setLocation(2);
        },
        onCancel() {
          that.updateLocationId(1);
          router.push("/ktm");
          that.clearCart();
          that.setLocation(1);
        },
      });
    } else if (LocationId.getLocationId() == 1) {
      router.push("/ktm");
    } else if (LocationId.getLocationId() == 2) {
      router.push("/pkr");
    }

    that.loadBanner();
  },
  watch: {
    $$route: function (n, o) {
      this.checkParams();
    },

    currentLocation(val) {
      this.megamenu(val);
    },
  },

  methods: {
    ...mapActions([
      "updateLocationId",
      "clearCart",
      "updateStep",
      "megamenu",
      "setLocation",
    ]),

    handleClose() {
      this.showPopup = false;
    },

    generateNewOrderID() {
      const orderID = this.orderNumber;
      const randomNo = Math.floor(Math.random() * 9000) + 1000;
      const newOrderID = orderID + "-" + randomNo;
      return newOrderID;
    },

    loadBanner: function () {
      GetBannerService.getItems(LocationId.getLocationId(), "")
        .then((response) => {
          let pushinfo = response.data.filter(
            (data) => data.type === "pushinfo"
          );

          this.popupBanner = pushinfo[0];

          if (pushinfo[0] != undefined) {
            this.showModal();
          }
        })
        .catch((err) => console.log(err));
    },

    checkParams() {
      // console.log("::" + this.$route.params.loc);

      if (this.$route.params.loc != undefined) {
        if (this.$route.params.loc == "ktm") {
          this.updateLocationId(1);

          router.push("/ktm");
        } else if (this.$route.params.loc == "pkr") {
          this.updateLocationId(2);
          router.push("/pkr");
        } else if (this.$route.params.loc == "checkout") {
        }
      }
    },

    showModal() {
      this.isModalVisible = true;
    },

    closeModal() {
      this.isModalVisible = false;
    },
  },
  mounted() {
    this.megamenu(LocationId.getLocationId());
  },
};
</script>

<style lang="scss">
.home {
  // border: 2px solid black;
  position: relative;
}
.home__popup {
  position: fixed;
  z-index: 9999999;
  top: 34vh;
  left: 10px;
  width: 35%;
  background-color: #ed2027;
  padding: 30px;
  border-radius: 10px;
  border: 2px solid #fff;
  box-shadow: 0 0px 6px rgb(0 0 0 / 10%);
}

.home__popup > img {
  height: 17px;
  position: absolute;
  right: 0;
  top: 5%;
  cursor: pointer;
  padding-right: 8px;
  margin-top: 5px;
}

.ant-modal-body {
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ant-modal-confirm-body {
  display: flex;
  justify-content: center;
  flex-direction: column;
  .ant-modal-confirm-title {
    text-align: center;
    margin-top: 20px !important;
    font-size: 18px !important;
  }
}
.ant-modal-confirm {
  .ant-modal-confirm-btns {
    float: none;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .ant-btn {
    height: 40px;
    font-size: 16px !important;
  }
}
</style>
